import {
  TelegramMessagePreview,
  type TelegramPreviewMedia,
} from "@core/components/telegram/preview/telegramMessagePreview"
import type { SlotOccurrence } from "@core/components/telegram/types"
import { fromVersionContent } from "../../hooks/useVersionDraft"
import type {
  ReadBindings,
  TemplateVersion,
} from "../../interface/publications"
import { bindingUrl, getActiveBindingSlots } from "../../utils/bindings"
import { useMediaPreview } from "../../hooks/useMediaPreview"
import { useMediaVisibility } from "../../hooks/useMediaVisibility"
import { Box } from "@mui/material"

/** Immutable source + separately resolved values. There is deliberately no onChange. */
export function PublicationContentView({
  version,
  bindings,
  onSelectOccurrence,
  media,
}: {
  version: TemplateVersion
  bindings: ReadBindings
  onSelectOccurrence?: (occurrence: SlotOccurrence) => void
  media?: readonly TelegramPreviewMedia[]
}) {
  const content = fromVersionContent(version.content)
  const { ref, visible } = useMediaVisibility()
  const descriptors = useMediaPreview(content.mediaIds, media, visible)
  return (
    <Box ref={ref}>
      <TelegramMessagePreview
        value={content}
        media={descriptors}
        slots={getActiveBindingSlots(content).map(({ slotId, label }) => ({
          id: slotId,
          label,
          url: bindingUrl(bindings[slotId]),
        }))}
        onSelectOccurrence={onSelectOccurrence}
      />
    </Box>
  )
}
